import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import CityPage from "@/pages/CityPage";
import SalaryInCityPage from "@/pages/SalaryInCityPage";
import CanIAffordPage from "@/pages/CanIAffordPage";
import ComparePage from "@/pages/ComparePage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import AdminPage from "@/pages/AdminPage";
import PrivacyPage from "@/pages/PrivacyPage";
import DynamicPage from "@/pages/DynamicPage";
import DisclaimerPage from "@/pages/DisclaimerPage";
import GenerateCityPage from "@/pages/GenerateCityPage";
import BudgetPlannerPage from "@/pages/BudgetPlannerPage";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ChatBot from "@/components/ChatBot";
import CookieConsent from "@/components/CookieConsent";
import StreakNudge from "@/components/StreakNudge";
import ScrollToTop from "@/components/ScrollToTop";
import AccessibilityWidget from "@/components/AccessibilityWidget";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-white">
        <Navbar />
        <main className="flex-1" id="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/compare" element={<ComparePage />} />
            <Route path="/compare/:cities" element={<ComparePage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/search-city" element={<GenerateCityPage />} />
            <Route path="/budget-planner" element={<BudgetPlannerPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<PrivacyPage />} />
            <Route path="/disclaimer" element={<DisclaimerPage />} />
            <Route path="/:pageSlug" element={<DynamicPage />} />
          </Routes>
        </main>
        <Footer />
        <ChatBot />
        <AccessibilityWidget />
        <CookieConsent />
        <StreakNudge />
        <Toaster position="top-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;
